if (!customElements.get('offer-price-note')) {
  customElements.define(
    'offer-price-note',
    class OfferPriceNote extends HTMLElement {
      connectedCallback() {
        const data = this.querySelector('script[type="application/json"]');
        if (!data) return;
        try {
          this.prices = JSON.parse(data.textContent);
        } catch (error) {
          return;
        }
        this.onVariantChange = this.onVariantChange.bind(this);
        document.addEventListener('change', this.onVariantChange);
      }

      disconnectedCallback() {
        if (this.prices) document.removeEventListener('change', this.onVariantChange);
      }

      onVariantChange(event) {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || input.name !== 'id') return;
        if (!input.closest(`#product-form-${this.dataset.section}`)) return;
        const price = this.prices[input.value];
        const target = this.querySelector('[data-offer-price]');
        if (price && target) {
          target.innerHTML = price;
          this.hidden = false;
        } else {
          this.hidden = true;
        }
      }
    }
  );
}
